<template>
  <div>
    <!-- Resultado de cada momento contable respectivamente -->
    <b-card no-body class="my-3">
      <b-tabs card>
        <b-tab v-for="res in importPoliza.result" :key="res.id" :title="res.content.poliza.momento">
          <polizas-s-a-card :item="res"></polizas-s-a-card>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PolizasSACard from '@/components/Polizas/SA/PolizasSACard'

export default {
  name: 'PolizasSATabs',

  components: {
    PolizasSACard
  },

  computed: {
    ...mapState('polizasSAModule', ['importPoliza'])
  }
}
</script>

<style lang="scss" scoped></style>
